import {Select} from 'antd'
import {
    docs_createDocRelationship_Api,
    docs_deleteCodiLink_Api,
    docs_deleteRelationship_Api,
    docs_editRelationship_Api,
    docs_fetchCodiDocumentRelations_Api,
    docs_fetchCodiRelations_Api,
    docs_fetchDetailCodiDocumentRelations_Api,
    docs_fetchDocRelations_Api,
    docs_generateRelationshipLinks_Api,
    docs_getDocRelationLinkDetails_Api,
} from 'apis'
import classNames from 'classnames'
import {showConfirm} from 'components/Feed/TimeLineFeed'
import {createValue} from 'components/form/utils'
import {LoginContext} from 'components/LoginContext'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import AsyncAction from 'modules/asyncCache/components/AsyncAction'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {BsBoxArrowInUpRight, BsFillForwardFill, BsMagic, BsTrash,} from 'react-icons/bs'
import {IoCloseCircleOutline} from 'react-icons/io5'
import {RiCircleFill} from 'react-icons/ri'
import {Link} from 'react-router-dom'
import {useToggle} from 'react-use'
import {DelayRender} from 'views/Discovery/DelayRender'
import createSettingBlock from 'views/Document/functions/createSettingBlock'
import {getLinkToDetailRow} from 'views/AppLocals/Codi/codiHelpers'
import {SelectWidget} from 'views/AppLocals/custom/ReactSelectComponents'
import EntityList from 'views/AppLocals/EntityList'
import {AppEntities} from 'views/AppLocals/enums'
import {showDeleteConfirmDialog} from 'views/AppLocals/factory/createConfirmDialog'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from 'views/AppLocals/factory/createNotification'
import {bindQueryParam, bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault, renderElse, renderIf} from 'views/Shared'
import LinkedDocumentBlock from '../LinkedDocumentBlock'
import DocumentBlock from './CodiDocumentBlock'
import {CodiSubHeader} from './CodiSiderHeading'
import {BiSolidChevronsDown, BiSolidChevronsUp} from "react-icons/bi";
import {LazyPagination} from "../../../../modules/asyncCache/components/LazyPagination";
import {docs_getCodiDocuments_Api} from "../../../../apis";
import {useSelector} from "react-redux";
import {getLang} from "../../../../redux/auth/selectors";
import TooltipApp from "components/TooltipApp";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import {ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import {GoDotFill} from "react-icons/go";

export const RelatedDocumentTypes = Object.freeze({
    INSTRUCTION: {
        key: 'instruction',
        label: 'guided documents',
        dependencies: ['instruction_prev_docs', 'instruction_next_docs'],
        value: {prev: 'instruction_prev_docs', next: 'instruction_next_docs'},
        labels: {prev: 'as a guide for', next: 'guided by'},
        options: [
            {
                label: 'as a guide for',
                value: 'instruction_prev_docs',
            },
            {
                label: 'guided by',
                value: 'instruction_next_docs',
            },
        ],
        related_type: 'instruction',
    },
    REFERENCE: {
        key: 'reference',
        label: 'reference documents',
        dependencies: ['reference_prev_docs', 'reference_next_docs'],
        value: {prev: 'reference_prev_docs', next: 'reference_next_docs'},
        labels: {prev: 'referenced by', next: 'as a reference for'},
        options: [
            {
                label: 'referenced by',
                value: 'reference_prev_docs',
            },
            {
                label: 'as a reference for',
                value: 'reference_next_docs',
            },
        ],
        related_type: 'reference',
    },
    BASIS: {
        key: 'basis',
        label: 'basis documents',
        dependencies: ['basis_prev_docs', 'basis_next_docs'],
        value: {prev: 'basis_prev_docs', next: 'basis_next_docs'},
        labels: {prev: 'based on', next: 'as a basis for'},
        options: [
            {
                label: 'based on',
                value: 'basis_prev_docs',
            },
            {
                label: 'as a basis for',
                value: 'basis_next_docs',
            },
        ],
        related_type: 'basis',
    },
    AMENDMENT: {
        key: 'amendment',
        label: 'amendment documents',
        dependencies: ['amendment_prev_docs', 'amendment_next_docs'],
        value: {prev: 'amendment_prev_docs', next: 'amendment_next_docs'},
        labels: {prev: 'as a amendment for', next: 'amended by'},
        options: [
            {
                label: 'as a modification for',
                value: 'amendment_prev_docs',
            },
            {
                label: 'modified by',
                value: 'amendment_next_docs',
            },
        ],
        related_type: 'amendment',
    },
    CORRECTION: {
        key: 'correction',
        label: 'correction documents',
        dependencies: ['correction_prev_docs', 'correction_next_docs'],
        value: {prev: 'correction_prev_docs', next: 'correction_next_docs'},
        labels: {prev: 'as a correction for', next: 'corrected by'},
        options: [
            {
                label: 'as a correction for',
                value: 'correction_prev_docs',
            },
            {
                label: 'corrected by',
                value: 'correction_next_docs',
            },
        ],
        related_type: 'correction',
    },
    REPLACEMENT: {
        key: 'replacement',
        label: 'replacement documents',
        dependencies: ['replacement_prev_docs', 'replacement_next_docs'],
        value: {prev: 'replacement_prev_docs', next: 'replacement_next_docs'},
        labels: {prev: 'as a replacement for', next: 'replaced by'},
        options: [
            {
                label: 'as a replacement for',
                value: 'replacement_prev_docs',
            },
            {
                label: 'replaced by',
                value: 'replacement_next_docs',
            },
        ],
        related_type: 'replacement',
    },
    CONSOLIDATION: {
        key: 'consolidation',
        label: 'consolidated documents',
        dependencies: ['consolidation_prev_docs', 'consolidation_next_docs'],
        value: {prev: 'consolidation_prev_docs', next: 'consolidation_next_docs'},
        labels: {prev: 'as a consolidation for', next: 'consolidated by'},
        options: [
            {
                label: 'as a consolidation for',
                value: 'consolidation_prev_docs',
            },
            {
                label: 'consolidated by',
                value: 'consolidation_next_docs',
            },
        ],
        related_type: 'consolidation',
    },
    RELEVANCE: {
        key: 'relevant_content',
        label: 'relevant documents',
        dependencies: ['relevance'],
        value: {next: 'relevance'},
        options: [],
        related_type: 'relevance',
    },
})

export const RelationshipStatus = Object.freeze({
    PENDING: {label: 'pending', value: -1},
    COMPLETED: {label: 'completed', value: 1},
    PROCESSING: {label: 'processing', value: 3},
})

const renderItemHistory = () => (item, index) => {
    const {link, owner, id} = item || {}
    const owner_codi = _.get(owner, 'codi_document')
    const link_codi = _.get(link, 'codi_document')

    const owner_tooltip = [
        getTitle(owner_codi),
        _.get(owner_codi, 'document_no'),
    ].join(' - ')

    const link_tooltip = [
        getTitle(link_codi),
        _.get(link_codi, 'document_no'),
    ].join(' - ')

    let params = {}
    switch (_.get(link, '_type')) {
        case AppEntities.CODI_DOCUMENT:
            params = (
                <Translate>
                    {(t) => (
                        <span className="space-x-1 text-xs">
              <span className="font-light text-color-400 italic lowercase">
                {t('document')}
              </span>
              <TooltipApp
                  title={[getTitle(link), _.get(link, 'document_no')].join(' ')}>
                <Link
                    to={getLinkToDetail(link)}
                    target="_blank"
                    className="font-semibold text-blue-600 hover:text-primary cursor-pointer">
                  {[
                      _.get(link, 'document_type'),
                      _.get(link, 'document_no'),
                  ].join(' ')}
                </Link>
              </TooltipApp>
            </span>
                    )}
                </Translate>
            )
            break
        case AppEntities.CODI_DOCUMENT_ROW:
            params = (
                <Translate>
                    {(t) => (
                        <span className="space-x-1 text-xs">
              <span className="font-semibold text-color-000">
                {_.get(link, 'short_index_name')}
              </span>
              <span className="font-light text-color-400 italic">
                {t('of')}
              </span>
              <TooltipApp title={link_tooltip}>
                <Link
                    to={getLinkToDetail(link)}
                    target="_blank"
                    className="font-semibold text-blue-600 hover:text-primary underline cursor-pointer">
                  {[
                      _.get(link_codi, 'document_type'),
                      _.get(link_codi, 'document_no'),
                  ].join(' ')}
                </Link>
              </TooltipApp>
            </span>
                    )}
                </Translate>
            )
            break
        default:
            break
    }

    let joinComponent = null
    switch (_.get(item, 'related_type')) {
        case 'replacement':
            joinComponent = (
                <Translate>
                    {(t) => (
                        <span className="font-light text-color-400 italic">
              {t('replaced for')}
            </span>
                    )}
                </Translate>
            )
            break
        case 'instruction':
            joinComponent = (
                <Translate>
                    {(t) => (
                        <span className="font-light text-color-400 italic">
              {t('has been guided by')}
            </span>
                    )}
                </Translate>
            )
            break
        default:
    }

    return (
        <Translate key={index}>
            {(t) => (
                <div className="flex items-center gap-2">
                    <div
                        style={{lineHeight: '1.3'}}
                        className="flex flex-1 items-center max-lines-2 space-x-1 text-xs">
                        <BsFillForwardFill
                            size={10}
                            className="text-color-400"
                        />
                        <span className="font-semibold text-color-000">
              {_.get(owner, 'short_index_name')}
            </span>
                        <span className="font-light text-color-400 italic">{t('of')}</span>
                        <TooltipApp title={owner_tooltip}>
              <span className="font-semibold text-blue-600 cursor-pointer">
                {[
                    _.get(owner_codi, 'document_type'),
                    _.get(owner_codi, 'document_no'),
                ].join(' ')}
              </span>
                        </TooltipApp>
                        {joinComponent}
                        {params}
                    </div>
                    <AsyncAction
                        apiInfo={docs_deleteCodiLink_Api}
                        onSuccess={(result, args) => {
                            successNotify(NotificationActionTypes.DELETE, t)
                        }}
                        onError={notifyOnError(t)}>
                        {({isLoading, handleAsyncAction}) => (
                            <IoCloseCircleOutline
                                className="text-red-300 hover:text-red-600 cursor-pointer"
                                size={14}
                                loading={isLoading}
                                onClick={() => {
                                    showDeleteConfirmDialog({
                                        translate: t,
                                        onOk: () => {
                                            handleAsyncAction({}, {id: id})
                                        },
                                    })
                                }}
                            />
                        )}
                    </AsyncAction>
                </div>
            )}
        </Translate>
    )
}

const ToggleLinkDetail = React.memo(({id, related_type}) => {
    const [isToggle, toggle] = useToggle()

    const ToggleIcon = ({icon, style, className, onClick}) => (
        <div
            style={style}
            onClick={onClick}
            className={classNames(
                'text-center cursor-pointer text-color-400 hover:text-color-100',
                className
            )}>
            {icon}
        </div>
    )

    return (
        <Translate>
            {(t) => (
                <div className="flex flex-col gap-2">
                    {isToggle && (
                        <div className="flex flex-col gap-2 m-2">
                            <div
                                className="font-medium text-xs text-color-500 border-b border-color-50 tracking-wide uppercase italic">
                                {t('change logs')}
                            </div>
                            <div className="flex flex-col gap-2">
                                <EntityList
                                    RenderEntity={React.Fragment}
                                    renderItem={renderItemHistory()}
                                    apiInfo={docs_getDocRelationLinkDetails_Api}
                                    query={bindQueryParams([{id}, {related_type}])}
                                />
                            </div>
                        </div>
                    )}
                    <ToggleIcon
                        onClick={toggle}
                        className="font-light text-xs italic"
                        icon={isToggle ? t('see less') : t('see more')}
                    />
                </div>
            )}
        </Translate>
    )
})

const renderRelationship =
    ({Footer = NullAsDefault, renderActions = NullAsDefault, subPath = 'rel_document'}) =>
        (item) => {
            // const { document, rel_document, status } = item || {}
            const rel_document = _.get(item, subPath)
            const {issued_place, published_date, document_no} = rel_document || {}

            return (
                <Translate key={item?.id}>
                    {(t) => (
                        <div className="flex flex-col p-2 background border border-color-50 rounded-lg">
                            <div className="flex gap-2">
                                <div className="flex flex-col gap-1 flex-1">
                                    <div className="flex items-center gap-1 text-sm max-lines-2 leading-tight">
                  <span className="font-semibold text-color-000">
                    {formatDate(published_date, 'DD/MM/YYYY')}
                      {' - '}
                  </span>
                                        <Link
                                            className="font-semibold text-primary"
                                            to={getLinkToDetail(rel_document)}>
                                            {getTitle(rel_document)}
                                        </Link>
                                    </div>
                                    {_.some([issued_place, document_no], Boolean) && (
                                        <div className="flex gap-1 text-xs italic">
                    <span className="text-color-100 font-medium truncate">
                      {getTitle(issued_place)} {' - '}
                    </span>
                                            <span className="space-x-1 font-medium text-color-100 whitespace-no-wrap">
                      <span className="font-normal text-color-400">
                        {`${t('document no')}: `}
                      </span>
                                                {document_no}
                    </span>
                                        </div>
                                    )}
                                </div>
                                {renderActions(item)}
                            </div>
                            <Footer item={item}/>
                        </div>
                    )}
                </Translate>
            )
        }

const UpdateStatus = ({value, options = [], onChange = NullAsDefault}) => {
    const t = useTranslate()
    const class_name =
        Number(value) === RelationshipStatus.COMPLETED.value
            ? 'status-completed'
            : Number(value) === RelationshipStatus.PENDING.value
            ? 'status-pending'
            : 'status-progress'
    return renderElse(
        _.isEmpty(options),
        <SelectWidget
            // status={status}
            size="small"
            className={classNames('text-xs', class_name)}
            value={value}
            onChange={(value) => {
                onChange(createValue('status', value))
            }}>
            {options.map(({label, value}, index) => {
                return (
                    <Select.Option
                        key={index}
                        value={value}
                        label={t(label)}>
                        {t(label)}
                    </Select.Option>
                )
            })}
        </SelectWidget>
    )
}

const DocumentSettingToggle = ({
                                   params,
                                   codi_id,
                                   rel_type,
                                   document_id,
                                   related_type,
                                   document_type_id,
                               }) => {
    const t = useTranslate()

    const apiInfo = docs_fetchDocRelations_Api

    const [refreshKey, setRefreshKey] = useState()

    const onReload = () => {
        setRefreshKey(Date.now())
    }

    const {handleAsyncAction: onCreate} = useAsyncAction({
        apiInfo: _.omit(docs_createDocRelationship_Api, ['schema', 'transform']),
        query: bindQueryParam({id: document_id}),
        onError: notifyOnError(t),
        onSuccess: () => {
            successNotify(NotificationActionTypes.CREATE, t)
            onReload()
        },
    })

    const {handleAsyncAction: onUpdate} = useAsyncAction({
        apiInfo: docs_editRelationship_Api,
        onError: notifyOnError(t),
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onReload()
        },
    })

    const {handleAsyncAction: onDelete} = useAsyncAction({
        apiInfo: docs_deleteRelationship_Api,
        onError: notifyOnError(t),
        onSuccess: () => {
            successNotify(NotificationActionTypes.DELETE, t)
            onReload()
        },
    })

    const confirmDelete = (relationship) => {
        showDeleteConfirmDialog({
            translate: t,
            onOk: () => {
                onDelete({}, {id: relationship?.id})
            },
        })
    }

    const {handleAsyncAction: onStartRelatedGeneration} = useAsyncAction({
        apiInfo: docs_generateRelationshipLinks_Api,
        onError: notifyOnError(t),
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onReload()
        },
    })

    const confirmStartRelatedGeneration = (relationship) => {
        showConfirm({
            title: (
                <div className="font-bold text-color-000">{t('are you sure')}</div>
            ),
            content: (
                <span className="text-sm text-color-300 italic">
          {t('are you sure you want to run the self-relationship step?')}
        </span>
            ),
            okText: t('sure'),
            cancelText: t('no'),
            okType: 'primary',
            okButtonProps: {
                className: 'button-rounded-lg no-border',
            },
            cancelButtonProps: {
                className: 'button-rounded-lg no-border',
            },
            onOk: () => {
                onStartRelatedGeneration({}, {id: relationship?.id})
            },
        })
    }

    const renderItem = useMemo(
        () =>
            renderRelationship({
                subPath: [
                    'replacement_prev_docs',
                    'amendment_prev_docs',
                    'instruction_prev_docs',
                    'consolidation_prev_docs',
                    'basis_prev_docs',
                    'reference_prev_docs',
                    'correction_prev_docs',
                ].includes(rel_type)
                    ? 'rel_document'
                    : 'document',
                Footer: ({item}) => (
                    <ToggleLinkDetail
                        id={item?.id}
                        related_type={related_type}
                    />
                ),
                renderActions: (item) => (
                    <div className="flex flex-col items-end justify-between gap-4">
                        <UpdateStatus
                            value={item?.status}
                            onChange={(event) => {
                                const {name, value} = event.target
                                onUpdate(
                                    {
                                        [name]: value,
                                    },
                                    {id: item?.id}
                                )
                            }}
                            options={[
                                RelationshipStatus.PENDING,
                                RelationshipStatus.PROCESSING,
                                RelationshipStatus.COMPLETED,
                            ]}
                        />
                        <div className="flex items-center gap-6">
                            <BsMagic
                                size={15}
                                className="text-blue-300 hover:text-blue-600 cursor-pointer"
                                onClick={() => {
                                    confirmStartRelatedGeneration(item)
                                }}
                            />
                            <BsTrash
                                size={15}
                                className="text-red-300 hover:text-red-600 cursor-pointer"
                                onClick={() => {
                                    confirmDelete(item)
                                }}
                            />
                        </div>
                    </div>
                ),
            }),
        [related_type, rel_type]
    )

    return createSettingBlock({
        params,
        apiInfo,
        onCreate,
        onUpdate,
        renderItem,
        document_id,
        onDelete: confirmDelete,
        values: document_type_id ? {document_type_id} : undefined,
        query: bindQueryParams([{rel_type}, {id: document_id}]),
        deps: [apiInfo?.path, codi_id, document_id, rel_type, refreshKey],
        render: ({toggle = NullAsDefault}) => (
            <BsBoxArrowInUpRight
                onClick={() => {
                    toggle(true)
                }}
                className="text-color-300 hover:text-primary cursor-pointer"
            />
        ),
    })
}

export const LinkedBlock = ({
                                style,
                                title,
                                subTitle,
                                className,
                                children,
                                action = null,
                            }) => (
    <div
        style={style}
        className={classNames('flex flex-col', className)}>
        <CodiSubHeader
            title={title}
            subTitle={subTitle}
        />
        {children}
    </div>
)

export const CodiDocumentSourceRelated = ({
                                              style,
                                              codi_id,
                                              className,
                                              document_id,
                                              header = null,
                                          }) => (
    <div
        style={style}
        className={classNames('flex flex-col', className)}>
        {header}
        <div className="flex flex-col gap-2">
            {[RelatedDocumentTypes.RELEVANCE].map((type, index) => (
                <DelayRender
                    lazy={true}
                    key={index}
                    time={_.defaultTo(10 * index, 0) + 50}>
                    <LinkedDocumentBlock
                        type={type}
                        apiInfo={docs_fetchDocRelations_Api}
                        query={bindQueryParams([
                            {id: document_id},
                            {rel_type: type.value.next},
                        ])}
                        renderHeader={() => (
                            <LinkedBlock
                                className="mb-2"
                                title={type.label}
                            />
                        )}
                    />
                </DelayRender>
            ))}
            {[
                RelatedDocumentTypes.AMENDMENT,
                RelatedDocumentTypes.CONSOLIDATION,
                RelatedDocumentTypes.CORRECTION,
                RelatedDocumentTypes.INSTRUCTION,
                RelatedDocumentTypes.REPLACEMENT,
                RelatedDocumentTypes.REFERENCE,
                RelatedDocumentTypes.BASIS,
            ].map((type, index) => (
                <React.Fragment key={index}>
                    <DelayRender
                        lazy={true}
                        time={_.defaultTo(10 * index, 0) + 50}>
                        <LinkedDocumentBlock
                            apiInfo={docs_fetchDocRelations_Api}
                            subPath="rel_document"
                            query={bindQueryParams([
                                {id: document_id},
                                {rel_type: type.value.prev},
                            ])}
                            renderHeader={() => (
                                <LinkedBlock
                                    className="mb-2"
                                    title={type.labels.prev}
                                />
                            )}
                        />
                    </DelayRender>
                    <DelayRender
                        lazy={true}
                        time={_.defaultTo(10 * index, 0) + 50}>
                        <LinkedDocumentBlock
                            apiInfo={docs_fetchDocRelations_Api}
                            subPath="document"
                            query={bindQueryParams([
                                {id: document_id},
                                {rel_type: type.value.next},
                            ])}
                            renderHeader={() => (
                                <LinkedBlock
                                    className="mb-2"
                                    title={type.labels.next}
                                />
                            )}
                        />
                    </DelayRender>
                </React.Fragment>
            ))}
        </div>
        <div className="h-10"/>
    </div>
)

const CodiDocumentSource = ({
                                style,
                                codi_id,
                                className,
                                document_id,
                                header = null,
                            }) => {
    const login = useContext(LoginContext)

    const {edit_system = false} = login || {}

    const renderAction = useCallback(
        ({title, subTitle, rel_type, params, related_type}) => (
            <div className="flex mb-2 items-center justify-between gap-2 border-b">
                <CodiSubHeader
                    title={title}
                    subTitle={subTitle}
                    bordered={false}
                />
                {!!edit_system && (
                    <DocumentSettingToggle
                        params={params}
                        codi_id={codi_id}
                        rel_type={rel_type}
                        document_id={document_id}
                        related_type={related_type}
                    />
                )}
            </div>
        ),
        [codi_id, edit_system, document_id]
    )

    return renderIf(
        codi_id,
        <div
            style={style}
            className={classNames('flex flex-col', className)}>
            {header}
            {[
                RelatedDocumentTypes.INSTRUCTION,
                RelatedDocumentTypes.REPLACEMENT,
                RelatedDocumentTypes.REFERENCE,
            ].map((type, index) => {
                const related_type = type.related_type
                return (
                    <React.Fragment key={index}>
                        <DelayRender
                            lazy={true}
                            time={_.defaultTo(10 * index, 0) + 50}>
                            <DocumentBlock
                                type={type}
                                subPath="document"
                                subCodiPath="codi_document"
                                apiInfo={docs_fetchCodiDocumentRelations_Api}
                                query={bindQueryParams([
                                    {id: codi_id},
                                    {rel_type: type.value.next},
                                ])}
                                renderHeader={() =>
                                    renderAction({
                                        title: type.labels.next,
                                        related_type,
                                        rel_type: type.value.next,
                                        params: {
                                            link_type: type.value.next,
                                            link_types: type.options,
                                            type: type.labels.next,
                                        },
                                    })
                                }
                            />
                        </DelayRender>
                        <DelayRender
                            lazy={true}
                            time={_.defaultTo(10 * index, 0) + 50}>
                            <DocumentBlock
                                type={type}
                                subPath="rel_document"
                                subCodiPath="rel_codi_document"
                                apiInfo={docs_fetchCodiDocumentRelations_Api}
                                query={bindQueryParams([
                                    {id: codi_id},
                                    {rel_type: type.value.prev},
                                ])}
                                renderHeader={() =>
                                    renderAction({
                                        title: type.labels.prev,
                                        related_type,
                                        rel_type: type.value.prev,
                                        params: {
                                            link_type: type.value.prev,
                                            link_types: type.options,
                                            type: type.labels.prev,
                                        },
                                    })
                                }
                            />
                        </DelayRender>
                    </React.Fragment>
                )
            })}
            <div className="h-16"/>
        </div>
    )
}

const DetailLinks = ({item, codi_id}) => {
    const t = useTranslate()
    const [isToggle, toggle] = useToggle()
    const {link, related_type} = item ?? {}
    return (
        <div className="flex flex-col gap-2 pt-2 text-xs leading-tight italic">
            {renderIf(
                isToggle,
                <EntityList
                    auto={false}
                    RenderEntity={React.Fragment}
                    apiInfo={docs_fetchDetailCodiDocumentRelations_Api}
                    renderLoadMore={({onClick}) => {
                        return (
                            <span
                                className="text-center text-color-400 hover:text-color-100 cursor-pointer"
                                onClick={onClick}>
                {t('more')}
              </span>
                        )
                    }}
                    renderItem={(item, index) => {
                        const codi_row = item?.link
                        const {short_index_name, content} = codi_row ?? {}
                        return (
                            <div key={index} className="space-x-1 text-xs italic leading-snug">
                                <RiCircleFill
                                    size={8}
                                    className="text-color-500"
                                />
                                <Link
                                    to={getLinkToDetailRow(codi_row)}
                                    className="font-medium text-color-000 no-underline">
                                    {`${short_index_name} : `}
                                </Link>
                                <span className="text-color-400">{content}</span>
                            </div>
                        )
                    }}
                    query={bindQueryParams([
                        {id: codi_id},
                        {link_id: link?.id},
                        {rel_type: related_type},
                    ])}
                />
            )}
            <span
                className="flex justify-end items-center text-color-400 hover:text-color-100 cursor-pointer px-2 gap-1"
                onClick={(event) => {
                    event.stopPropagation()
                    toggle()
                }}>
        {isToggle ? <BiSolidChevronsUp/> : <BiSolidChevronsDown/>}
                <span>{t(isToggle ? 'see less' : 'detail')}</span>
      </span>
        </div>
    )
}

const getPathDocumentType = (documentType) => {
    const documentTypePath = _.get(documentType, 'title')
    if (!!_.get(documentType, 'parent')) {
        return [
            getPathDocumentType(_.get(documentType, 'parent')),
            documentTypePath,
        ].join(' - ')
    }
    return documentTypePath
}

export const RelatedCodiReferences = ({style, codi_id, className}) => {
    const renderTitle = (item) => {
        const {link} = item ?? {}
        const title = getTitle(link)
        const {document_no, document_type} = link ?? {}
        return renderIf(
            link,
            <div className="flex flex-col">
                <TooltipApp title={title}>
                    <div className="flex items-center gap-1 leading-snug">
                        <Link
                            target="_blank"
                            className="font-bold text-sm text-primary truncate"
                            to={getLinkToDetail(link)}>
                            {title}
                        </Link>
                        {document_no && (
                            <span className="font-medium text-xs text-color-500 italic whitespace-no-wrap">
                {`(${document_no})`}
              </span>
                        )}
                    </div>
                </TooltipApp>
                {renderIf(
                    document_type,
                    <span className="font-medium text-xs text-green-700 leading-tight italic">
            {getPathDocumentType(document_type)}
          </span>
                )}
            </div>
        )
    }

    const renderDescription = (item) => (
        <DetailLinks
            item={item}
            codi_id={codi_id}
        />
    )

    const block_params = {
        renderTitle,
        renderDescription,
        hideOnEmpty: true,
        apiInfo: docs_fetchCodiRelations_Api,
    }

    return renderIf(
        codi_id,
        <div
            style={style}
            className={classNames('flex flex-col', className)}>
            {[RelatedDocumentTypes.REFERENCE].map((type, index) => {
                const {value} = type ?? {}
                const delay = 10 * index + 50
                return (
                    <React.Fragment key={index}>
                        <DelayRender
                            lazy={true}
                            time={delay}>
                            <DocumentBlock
                                {...{type, ...block_params}}
                                query={bindQueryParams([
                                    {id: codi_id},
                                    {rel_type: value?.prev},
                                ])}
                            />
                        </DelayRender>
                    </React.Fragment>
                )
            })}
            <div className="h-16"/>
        </div>
    )
}


export const BrosCodiDocuments = ({codi_id, codi_document_type_id, style, className}) => {
    const renderItem = (item) => {
        const title = getTitle(item)
        const {document_no, document_type} = item ?? {}

        return renderIf(
            !!item && item?.id !== codi_id,
            <Translate>
                {t => (
                    <div className="flex flex-col">
                        <div className="flex items-center gap-1 leading-snug">
                            <Link
                                target="_blank"
                                className="font-bold text-sm truncate no-underline"
                                to={getLinkToDetail(item)}>
                                <GoDotFill size={10} className="mr-1 text-color-400"/>
                                {title}
                            </Link>
                            {document_no && (
                                <span className="font-medium text-xs text-secondary-400 italic whitespace-no-wrap">
                            {`(${document_no})`}
                        </span>
                            )}
                        </div>
                        <ItemInformation label={t('version')} value={item?.version} className="ml-3 text-xs italic"/>
                    </div>
                )}
            </Translate>
        )
    }
    const lang = useSelector(getLang)

    return renderIf(
        codi_document_type_id,
        <div
            style={style}
            className={classNames('flex flex-col space-y-3', className)}>
            <LazyPagination
                renderEmpty={() => null}
                apiInfo={docs_getCodiDocuments_Api}
                values={{document_type_id: codi_document_type_id, language: lang}}
                renderItem={renderItem}
            />
        </div>
    )
}

export default CodiDocumentSource
